/**
 * Format a numeric value with dot as thousands separator (de-DE locale).
 * Suitable as a DataGridPro valueFormatter.
 */
export const formatNumberDE = (value) => {
  if (value == null || value === '') return '';
  const n =
    typeof value === 'number'
      ? value
      : parseFloat(String(value).replace(/[, ]+/g, ''));
  if (Number.isNaN(n)) return String(value);
  return n.toLocaleString('de-DE');
};
